
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import EventsList from "./pages/events/EventsList";
import AddEvent from "./pages/events/AddEvent";
import EditEvent from "./pages/events/EditEvent";
import Participants from "./pages/Participants";
import Rubric from "./pages/Rubric";
import Resources from "./pages/Resources";
import AddResource from "./pages/AddResource";
import EditResource from "./pages/EditResource";
import ResourceCategory from "./pages/ResourceCategory";
import AssignResources from "./pages/AssignResources";
import AssignResourcesToHackathon from "./pages/AssignResourcesToHackathon";
import Submissions from "./pages/Submissions";
import SubmissionDetails from "./pages/SubmissionDetails";
import Projects from "./pages/Projects";
import AddProject from "./pages/AddProject";
import EditProject from "./pages/EditProject";
import ProjectsDetails from "./pages/ProjectsDetails";
import Countdown from "./pages/Countdown";
import LoginLayout from "./components/LoginLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import Hackathon from "./pages/Hackathon";
import WeeklySubmission from "./pages/WeeklySubmission";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route
          path="/login"
          element={
            <LoginLayout>
              <Login />
            </LoginLayout>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/hackathons"
          element={
            <ProtectedRoute>
              <Layout>
                <Hackathon />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/events"
          element={
            <ProtectedRoute>
              <Layout>
                <EventsList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/add"
          element={
            <ProtectedRoute>
              <Layout>
                <AddEvent />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/edit/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <EditEvent />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/participants"
          element={
            <ProtectedRoute>
              <Layout>
                <Participants />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/rubric"
          element={
            <ProtectedRoute>
              <Layout>
                <Rubric />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/resources"
          element={
            <ProtectedRoute>
              <Layout>
                <Resources />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/resources/add-resource"
          element={
            <ProtectedRoute>
              <Layout>
                <AddResource />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/resources/edit-resource/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <EditResource />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/resources/categories"
          element={
            <ProtectedRoute>
              <Layout>
                <ResourceCategory />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/resources/assign-resources"
          element={
            <ProtectedRoute>
              <Layout>
                <AssignResources />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/resources/assign-resources/:hackathonId"
          element={
            <ProtectedRoute>
              <Layout>
                <AssignResourcesToHackathon />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/submissions"
          element={
            <ProtectedRoute>
              <Layout>
                <Submissions />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/submissions/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <SubmissionDetails />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects"
          element={
            <ProtectedRoute>
              <Layout>
                <Projects />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/add"
          element={
            <ProtectedRoute>
              <Layout>
                <AddProject />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/edit/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <EditProject />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <ProjectsDetails />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/countdown"
          element={
            <ProtectedRoute>
              <Layout>
                <Countdown />
              </Layout>
            </ProtectedRoute>
          }
        />
      <Route
          path="/weekly-submissions"
          element={
            <ProtectedRoute>
              <Layout>
                <WeeklySubmission />
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
